import { defineMessage } from "react-intl";

export const formulationMessages = {
  injection: defineMessage({
    id: "medication.formulation.injection",
    defaultMessage: "injection",
  }),
  tablets: defineMessage({
    id: "medication.formulation.tablets",
    defaultMessage: "tablets",
  }),
  solution: defineMessage({
    id: "medication.formulation.solution",
    defaultMessage: "solution",
  }),
  ointment: defineMessage({
    id: "medication.formulation.ointment",
    defaultMessage: "ointment",
  }),
  cream: defineMessage({
    id: "medication.formulation.cream",
    defaultMessage: "cream",
  }),
  lotion: defineMessage({
    id: "medication.formulation.lotion",
    defaultMessage: "lotion",
  }),
  unit: defineMessage({
    id: "medication.formulation.unit",
    defaultMessage: "unit",
  }),
  caps: defineMessage({
    id: "medication.formulation.caps",
    defaultMessage: "caps",
  }),
  "dispersible tablets": defineMessage({
    id: "medication.formulation.dispersibleTablets",
    defaultMessage: "dispersible tablets",
  }),
  suspension: defineMessage({
    id: "medication.formulation.suspension",
    defaultMessage: "suspension",
  }),
  all: defineMessage({
    id: "medication.formulation.all",
    defaultMessage: "all",
  }),
  drops: defineMessage({
    id: "medication.formulation.drops",
    defaultMessage: "drops",
  }),
  syrup: defineMessage({
    id: "medication.formulation.syrup",
    defaultMessage: "syrup",
  }),
  inhaler: defineMessage({
    id: "medication.formulation.inhaler",
    defaultMessage: "inhaler",
  }),
  "powder for injection": defineMessage({
    id: "medication.formulation.powderForInjection",
    defaultMessage: "powder for injection",
  }),
  oral: defineMessage({
    id: "medication.formulation.oral",
    defaultMessage: "oral",
  }),
  "chewable tab": defineMessage({
    id: "medication.formulation.chewableTab",
    defaultMessage: "chewable tab",
  }),
  powder: defineMessage({
    id: "medication.formulation.powder",
    defaultMessage: "powder",
  }),
  gel: defineMessage({
    id: "medication.formulation.gel",
    defaultMessage: "gel",
  }),
  pessaries: defineMessage({
    id: "medication.formulation.pessaries",
    defaultMessage: "pessaries",
  }),
  "iv infusion": defineMessage({
    id: "medication.formulation.ivInfusion",
    defaultMessage: "iv infusion",
  }),
  infusion: defineMessage({
    id: "medication.formulation.infusion",
    defaultMessage: "infusion",
  }),
  female: defineMessage({
    id: "medication.formulation.female",
    defaultMessage: "female",
  }),
  male: defineMessage({
    id: "medication.formulation.male",
    defaultMessage: "male",
  }),
  iud: defineMessage({
    id: "medication.formulation.iud",
    defaultMessage: "iud",
  }),
  suppositories: defineMessage({
    id: "medication.formulation.suppositories",
    defaultMessage: "suppositories",
  }),
  elixir: defineMessage({
    id: "medication.formulation.elixir",
    defaultMessage: "elixir",
  }),
  enema: defineMessage({
    id: "medication.formulation.enema",
    defaultMessage: "enema",
  }),
  implant: defineMessage({
    id: "medication.formulation.implant",
    defaultMessage: "implant",
  }),
  inhalation: defineMessage({
    id: "medication.formulation.inhalation",
    defaultMessage: "inhalation",
  }),
  "resp solution": defineMessage({
    id: "medication.formulation.respSolution",
    defaultMessage: "resp solution",
  }),
  emolient: defineMessage({
    id: "medication.formulation.emolient",
    defaultMessage: "emolient",
  }),
  pellets: defineMessage({
    id: "medication.formulation.pellets",
    defaultMessage: "pellets",
  }),
  granules: defineMessage({
    id: "medication.formulation.granules",
    defaultMessage: "granules",
  }),
  liquid: defineMessage({
    id: "medication.formulation.liquid",
    defaultMessage: "liquid",
  }),
  // TODO: fix tablet vs tablets
  tablet: defineMessage({
    id: "medication.formulation.tablet",
    defaultMessage: "tablet",
  }),
  "tablets/syrup": defineMessage({
    id: "medication.formulation.tabletsForSyrup",
    defaultMessage: "tablets/syrup",
  }),
  bottle: defineMessage({
    id: "medication.formulation.bottle",
    defaultMessage: "bottle",
  }),
  dressing: defineMessage({
    id: "medication.formulation.dressing",
    defaultMessage: "dressing",
  }),
  sachet: defineMessage({
    id: "medication.formulation.sachet",
    defaultMessage: "sachet",
  }),
  pencil: defineMessage({
    id: "medication.formulation.pencil",
    defaultMessage: "pencil",
  }),
  spray: defineMessage({
    id: "medication.formulation.spray",
    defaultMessage: "spray",
  }),
  "eye drops": defineMessage({
    id: "medication.formulation.eyeDrops",
    defaultMessage: "eye drops",
  }),
  "ear drops": defineMessage({
    id: "medication.formulation.earDrops",
    defaultMessage: "ear drops",
  }),
  "eye ointment": defineMessage({
    id: "medication.formulation.eyeOintment",
    defaultMessage: "eye ointment",
  }),
  "eye/ear drops": defineMessage({
    id: "medication.formulation.eyeEarDrops",
    defaultMessage: "eye/ear drops",
  }),
  mouthwash: defineMessage({
    id: "medication.formulation.mouthwash",
    defaultMessage: "mouthwash",
  }),
  "nasal drops": defineMessage({
    id: "medication.formulation.nasalDrops",
    defaultMessage: "nasal drops",
  }),
  "nebuliser solution": defineMessage({
    id: "medication.formulation.nebuliserSolution",
    defaultMessage: "nebuliser solution",
  }),
  "oral drops": defineMessage({
    id: "medication.formulation.oralDrops",
    defaultMessage: "oral drops",
  }),
  patch: defineMessage({
    id: "medication.formulation.patch",
    defaultMessage: "patch",
  }),
  "topical gel": defineMessage({
    id: "medication.formulation.topicalGel",
    defaultMessage: "topical gel",
  }),
};

export const doseMessages = {
  mg: defineMessage({
    id: "prescription.dose.unit.mg",
    defaultMessage: "mg",
  }),
  micrograms: defineMessage({
    id: "prescription.dose.unit.micrograms",
    defaultMessage: "{value, plural, one {microgram} other {micrograms}}",
  }),
  g: defineMessage({
    id: "prescription.dose.unit.g",
    defaultMessage: "g",
  }),
  tablet: defineMessage({
    id: "prescription.dose.unit.tablet",
    defaultMessage: "{value, plural, one {tablet} other {tablets}}",
  }),
  ml: defineMessage({
    id: "prescription.dose.unit.ml",
    defaultMessage: "mL",
  }),
  drop: defineMessage({
    id: "prescription.dose.unit.drop",
    defaultMessage: "{value, plural, one {drop} other {drops}}",
  }),
  puff: defineMessage({
    id: "prescription.dose.unit.puff",
    defaultMessage: "{value, plural, one {puff} other {puffs}}",
  }),
  unit: defineMessage({
    id: "prescription.dose.unit.unit",
    defaultMessage: "{value, plural, one {unit} other {units}}",
  }),
  capsule: defineMessage({
    id: "prescription.dose.unit.capsule",
    defaultMessage: "{value, plural, one {capsule} other {capsules}}",
  }),
  application: defineMessage({
    id: "prescription.dose.unit.application",
    defaultMessage: "{value, plural, one {application} other {applications}}",
  }),
  customDose: defineMessage({
    id: "prescription.dose.unit.custom",
    defaultMessage: "{value, plural, one {custom dose} other {custom doses}}",
  }),
  patch: defineMessage({
    id: "prescription.dose.unit.patch",
    defaultMessage: "{value, plural, one {patch} other {patches}}",
  }),
  sachet: defineMessage({
    id: "prescription.dose.unit.sachet",
    defaultMessage: "{value, plural, one {sachet} other {sachets}}",
  }),
  suppository: defineMessage({
    id: "prescription.dose.unit.suppository",
    defaultMessage: "{value, plural, one {suppository} other {suppositories}}",
  }),
  pessary: defineMessage({
    id: "prescription.dose.unit.pessary",
    defaultMessage: "{value, plural, one {pessary} other {pessaries}}",
  }),
  device: defineMessage({
    id: "prescription.dose.unit.device",
    defaultMessage: "{value, plural, one {device} other {devices}}",
  }),
  spray: defineMessage({
    id: "prescription.dose.unit.spray",
    defaultMessage: "{value, plural, one {spray} other {sprays}}",
  }),
};

export const frequencyMessages = {
  day: defineMessage({
    id: "prescription.frequency.unit.day",
    defaultMessage: "{value, plural, one {day} other {days}}",
  }),
  week: defineMessage({
    id: "prescription.frequency.unit.week",
    defaultMessage: "{value, plural, one {week} other {weeks}}",
  }),
  month: defineMessage({
    id: "prescription.frequency.unit.month",
    defaultMessage: "{value, plural, one {month} other {months}}",
  }),
};

export const doseQuantityMsg = defineMessage({
  id: "prescription.dose.quantity",
  defaultMessage: "{value} {value, plural, one {dose} other {doses}}",
});

export const doseRateFrequencyMsg = defineMessage({
  id: "prescription.dose.frequency",
  defaultMessage: "{value, plural, one {time} other {times}} per",
});

export const durationQuantityMsg = defineMessage({
  id: "prescription.dose.duration",
  defaultMessage: "For {value} {unit}",
});
